<template>
    <div v-if="Object.keys(orderData).length > 0" ref="moveToCompletedModal" class="modal fade" id="moveToCompleted" tabindex="-1">
        <div class="modal-dialog modal-lg">
            <div class="modal-content bg-white">
                <div class="modal-header">
                    <h5 class="modal-title">Mark Order as Completed</h5>
                    <!-- <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button> -->
                </div>
                <div class="modal-body">
                    <form class="row g-3">
                        <!-- First display existing services -->
                        <div
                            class="row mb-3"
                            v-if="orderData.services.length > 0"
                            v-for="(service, index) in orderData.services"
                        >
                            <div class="col-md-5">
                                <template v-if="index === 0">
                                    <label for="customer_name" class="form-label">Service Name</label>
                                </template>
                                <VueSelect
                                    :key="index"
                                    v-model="service.service_id"
                                    :items="serviceOptions"
                                    :taggable="true"
                                    @onSelectOption="selectService(index, $event)"
                                />
                            </div>
                            <div class="col-md-2 item-fields-number">
                                <template v-if="index === 0">
                                    <label for="item_price" class="form-label">Item Cost</label>
                                </template>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="item_price"
                                    v-model="service.order_item_price"
                                    @input="calculateServiceItemAmount(index)"
                                />
                            </div>
                            <div class="col-md-2 item-fields-number">
                                <template v-if="index === 0">
                                    <label for="labour_cost" class="form-label">Labour Cost</label>
                                </template>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="labour_cost"
                                    v-model="service.order_item_labour_cost"
                                    @input="calculateServiceItemAmount(index)"
                                />
                            </div>
                            <div class="col-md-2 item-fields-number">
                                <template v-if="index === 0">
                                    <label for="discount" class="form-label">Discount(%)</label>
                                </template>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="order_item_discount_value"
                                    v-model="service.order_item_discount_value"
                                    @input="validateInput('service', index); calculateServiceItemAmount(index)"
                                />
                            </div>
                            <div class="col-md-1 text-nowrap ps-0">
                                <template v-if="index === 0">
                                    <div class="mt-4"></div>
                                </template>
                                <button
                                    v-if="Object.keys(orderData.services).length > 1"
                                    type="button"
                                    class="btn btn-sm btn-danger"
                                    @click="removeOrderItem(index)"
                                    style="left: 30px"
                                >
                                    <i class="bi bi-trash"></i>
                                </button>
                                <button
                                    v-if="Object.keys(orderData.services).length -1 === index"
                                    type="button"
                                    class="btn btn-sm btn-theme ms-1"
                                    @click="addMoreServiceItem"
                                >
                                    <i class="bi bi-plus-circle"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-4">
                                    <label for="invoice_number" class="form-label">Invoice Number</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="invoice_number"
                                        placeholder="Enter Invoice Number"
                                        v-model="orderData.invoice_number"
                                        :class="{ 'is-invalid': orderData.invoice_number==='' && orderData.submit_form }"
                                    />
                                    <div class="is-invalid invalid-feedback">This field is required.</div>
                                </div>
                                <div class="col-md-4">
                                    <label for="invoice_date" class="form-label">Invoice Date</label>
                                    <BookingDatePicker
                                        v-model="orderData.invoice_date"
                                        :format="'dd-MM-yyyy'"
                                        :time-picker="false"
                                        :display-marker="false"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label for="invoice_due_at" class="form-label">Invoice Due at</label>
                                    <VueSelect
                                        v-model="orderData.invoice_due_at"
                                        id="invoice_due_at"
                                        :items="[{'id': '0', 'name': 'Invoice Date'}, {'id': '2', 'name': 'After 2 Days'}, {'id': '7', 'name': 'After 7 Days'}, {'id': '15', 'name': 'After 15 Days'}, {'id': '30', 'name': 'After 30 Days'}]"
                                        :placeholder="'Select Due At'"
                                        :searchable="false"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="description" class="form-label">Comment</label>
                                    <textarea
                                        class="form-control"
                                        id="description"
                                        rows="4"
                                        v-model="orderData.comment"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="discount" class="form-label">Total Amount</label>
                                    <input
                                        readonly
                                        type="number"
                                        class="form-control"
                                        id="order_item_discount_value"
                                        v-model="orderData.item_total"
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="discount" class="form-label">Discount(%)</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        id="order_item_discount_value"
                                        v-model="orderData.discount_value"
                                        @input="calculateTotalAmount"
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="discount" class="form-label">VAT(%)</label>
                                    <VueSelect
                                        v-model="orderData.tax"
                                        :items="[{ id: '0', name: '0' },{ id: tax, name: tax }]"
                                        :placeholder="'Select VAT'"
                                        :searchable="false"
                                        @onSelectOption="onTaxChanged"
                                    ></VueSelect>
                                </div>
                                <div class="col-md-6">
                                    <label for="discount" class="form-label">Net Amount</label>
                                    <input
                                        readonly
                                        type="number"
                                        class="form-control"
                                        id="order_item_discount_value"
                                        v-model="orderData.final_amount"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <label for="description" class="form-label">Attachment</label>
                            <ImageUploader ref="imageUploader" :orderId="orderData.id" />
                        </div>
                        <div class="col-md-12">
                            <div class="form-check form-switch">
                                <input class="form-check-input cursor-pointer" type="checkbox" id="certificate" v-model="displayRecurringServices">
                                <label class="form-check-label cursor-pointer" for="certificate">{{ displayRecurringServices ? 'Hide Recurring Services' : 'Show Recurring Services'}}</label>
                            </div>
                        </div>

                        <RecurringServices
                            v-if="displayRecurringServices && orderData.customer_id"
                            :order-data="orderData"
                            ref="recurringServices"
                        ></RecurringServices>
                    </form>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        @click="hideModal"
                    >Cancel</button>
                    <button
                        type="button"
                        class="btn btn-theme btn-sm"
                        v-text="processing ? 'Loading...' : 'Submit'"
                        @click="updateOrder"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueSelect from '../partials/VueSelect.vue';
import ImageUploader from './ImageUploader.vue';
import RecurringServices from '../RecurringServices.vue';
export default {
    components: {
        VueSelect,
        ImageUploader,
        RecurringServices,
    },
    props: {
        order: {
            type: Object,
            required: true
        },
        action: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            processing: false,
            tax: 20,
            orderData: {},
            services: [],
            serviceOptions: [],
            displayRecurringServices: true,
        };
    },
    mounted() {
        this.getServicesForOrder();

        // Add a new node itemTotal in the orderData
        this.orderData = {
            id: this.order.id,
            provider_id: this.order.provider_id,
            company_id: this.order.company_id,
            customer_id: this.order.customer_id,
            address_id: this.order.address_id,
            comment: this.order.comment,
            status: this.order.status,
            item_total: this.order.services.reduce((total, service) => total + service.labour_cost + service.price, 0),
            discount_value: this.order.discount_value,
            discount_amount: this.order.discount_amount,
            tax: this.order.tax || this.tax,
            tax_amount: this.order.tax_amount,
            total_amount: this.order.total_amount,
            final_amount: this.order.final_amount,
            invoice_number: this.order.invoice_number,
            invoice_date: this.order.invoice_date,
            invoice_due_at: this.order.invoice_due_at,
            services: this.order.services.map(service => ({
                item_type: 'service',
                service_id: service.service_id,
                order_item_id: service.id,
                order_item_price: service.price,
                order_item_labour_cost: service.labour_cost,
                order_item_discount_type: service.discount_type,
                order_item_discount_value: service.discount_value,
                order_item_tax: service.tax || this.tax,
                order_item_total_amount: service.total_amount,
                order_item_sub_total_amount: service.sub_total_amount,
            })),
            old_items: this.order.services.map(service => ({
                item_type: 'service',
                service_id: service.service_id,
                order_item_id: service.id,
                order_item_price: service.price,
                order_item_labour_cost: service.labour_cost,
                order_item_discount_type: service.discount_type,
                order_item_discount_value: service.discount_value,
                order_item_tax: service.tax || this.tax,
                order_item_total_amount: service.total_amount,
                order_item_sub_total_amount: service.sub_total_amount,
            })),
        };
    },
    methods: {
        getServicesForOrder() {
            let self = this;
            axios
                .post("/admin/services/get-services-for-order", {})
                .then((response) => {
                    self.services = response.data.services;

                    // Prepare service options
                    self.serviceOptions = [{ id: " ", text: "Select Service", name: "Select Service" }];
                    response.data.services.forEach((service) => {
                        self.serviceOptions.push({
                            id: service.id,
                            text: service?.name,
                            name: service?.name
                        });
                    });
                });
        },
        showModal() {
            $('#moveToCompleted').modal('show');
        },
        hideModal() {
            $('#moveToCompleted').modal('hide');

            this.$emitter.emit('reset-selected-order');
        },
        addMoreServiceItem() {
            if (this.orderData.services.length < this.services.length) {
                this.orderData.services.push({
                    service_id: "",
                    order_item_id: "",
                    order_item_price: "",
                    order_item_labour_cost: 0,
                    order_item_discount_type: "",
                    order_item_discount_value: 0,
                    order_item_tax: 0,
                    order_item_discount_amount: 0,
                    order_item_tax_amount: 0,
                    order_item_total_amount: 0,
                    order_item_sub_total_amount: 0,
                    item_type: "service",
                });
            }
        },
        removeOrderItem(index) {
            this.orderData.services.splice(index, 1);
            this.calculateTotalAmount();
        },
        selectService(index, event) {
           // Find the service with service_id
           let service = this.services.find(service => service.id === event.id);
           this.orderData.services[index].service_name = service.name;
           this.orderData.services[index].order_item_price = service.price || 0;
           this.orderData.services[index].order_item_labour_cost = service.labour_cost || 0;
           this.orderData.services[index].order_item_discount_type = service.discount_type || "";
           this.orderData.services[index].order_item_discount_value = service.discount_value || 0;
           this.orderData.services[index].order_item_tax = this.tax;
           this.orderData.services[index].order_item_discount_amount = service.discount_amount || 0;
           this.orderData.services[index].order_item_tax_amount = service.tax_amount || 0;
           this.orderData.services[index].order_item_total_amount = service.total_amount || 0;
           this.orderData.services[index].order_item_sub_total_amount = service.sub_total_amount || 0;
           this.orderData.services[index].item_type = "service";
           this.orderData.services[index].service_id = service.id;

           // Calculate total amount
           this.calculateServiceItemAmount(index);
        },
        validateInput(index) {
            // validate discount value
            if (this.orderData.services[index].order_item_discount_value < 0) {
                this.orderData.services[index].order_item_discount_value = 0;
            }
            else if (this.orderData.services[index].order_item_discount_value > 100) {
                this.orderData.services[index].order_item_discount_value = 100;
            }
        },
        calculateServiceItemAmount(index) {
            // Calculate service item amount
            let service = this.orderData.services[index];
            
            let price = Number(service.order_item_price) || 0;
            let labour_cost = Number(service.order_item_labour_cost) || 0;
            
            let subTotalAmount = price + labour_cost;
            let discountAmount = subTotalAmount * (service.order_item_discount_value / 100);
            let discountedAmount = subTotalAmount - discountAmount;
            let taxAmount = discountedAmount * (this.tax / 100);
            let totalAmount = discountedAmount + taxAmount;
            
            this.orderData.services[index].order_item_sub_total_amount = subTotalAmount;
            this.orderData.services[index].order_item_discount_amount = discountAmount;
            this.orderData.services[index].order_item_tax_amount = taxAmount;
            this.orderData.services[index].order_item_total_amount = totalAmount;

            // Calculate total amount
            this.calculateTotalAmount();
        },
        calculateTotalAmount() {
            // Calculate total amount
            let totalAmount = 0;
            this.orderData.services.forEach((service) => {
                let price = Number(service.order_item_price) || 0;
                let labour_cost = Number(service.order_item_labour_cost) || 0;
                totalAmount += Number(price + labour_cost) || 0;
            });

            this.orderData.item_total = totalAmount.toFixed(2);

            // Calculate discount amount
            this.orderData.discount_amount = Number(this.orderData.item_total) * (Number(this.orderData.discount_value) / 100);

            // Calculate tax amount
            this.orderData.tax_amount = Number(this.orderData.item_total) * (Number(this.orderData.tax) / 100);

            // Calculate final amount
            let finalAmount = Number(this.orderData.item_total) + Number(this.orderData.tax_amount) - Number(this.orderData.discount_amount);
            this.orderData.final_amount = finalAmount.toFixed(2);
        },
        onTaxChanged(event) {
            this.calculateTotalAmount();
        },
        updateOrder() {
            console.log(this.orderData.invoice_number);
            if (!this.orderData.invoice_number) {
                this.$notification('error', 'Please provide an invoice number.');
                return;
            }

            // Check if recurring services are enabled and not added then show error
            if(this.displayRecurringServices && !this.$refs.recurringServices?.isServiceModified) {
                // Show confirmation alert
                if (!confirm("You have not chosen a date for recurring services. Would you like to continue or please enter a date?")) {
                    return; // Stop form submission if user selects "Cancel"
                }
            }

            const config = {
                headers: { "content-type": "multipart/form-data" },
            };

            // Prepre comment
            let comment = this.orderData.comment || '';
            if (comment.length > 0) {
                comment += " - ";
            }

            comment += "Moved from " + this.orderData.status.toUpperCase() + " to Completed.";

            let postData = {
                order_id: this.orderData.id,
                comment: comment,
                discount: this.orderData.discount_value,
                tax: this.orderData.tax,
                services: this.orderData.services,
                files: this.$refs.imageUploader.files.map((file) => file.file),
                status: this.action === 'move_to_quotation' ? 'quotation' : 'canceled',
                old_items: this.orderData.old_items,
            };

            axios.post('/admin/orders/update-order', postData, config)
                .then((response) => {
                    this.$notification(response.data.status, response.data.message);
                    this.hideModal();

                    // Reset the image uploader
                    this.$refs.imageUploader.clearFiles();

                    // Emit an event to refresh the order list
                    this.$emitter.emit('refresh-order-list', {order: this.orderData});
                })
                .catch((error) => {
                    this.$notification('error', error.response.data.message);
                });
        },
    },
};
</script>